import { useState, useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Modal } from 'react-bootstrap';
import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';
import axios from 'axios';
import { parseISO } from 'date-fns';

import { useTranslation } from 'react-i18next';
import usePreciosCalendario from '../Compartido/usePreciosCalendario.js';
import limpiarHtml from '../Compartido/limpiarHtml.js';

const DatosPropiedad = ({ propiedad, servicios, politicas, diasbloqueados, primerdialibre, calendario, lang, config, extras, llegada, salida, adultos, ninos, bebes, configweb, moneda, destino, diasbloqueadossolos, diasbloqueadoscal }) => {

    const { t } = useTranslation();

    // 'yyyy-MM-dd' local (no toISOString: evita el desfase per zona horària),
    // mateixa clau que retorna PaginasController::preciosBuscadorGeneral.
    const fechaAPreciosKey = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    // Preus per dia al calendari, carregats a poc a poc (2 mesos cada cop)
    // a mida que es navega. Si la petició falla (p. ex. dins d'un iframe
    // sense cookies) el calendari continua funcionant, només sense preus.
    const { preciosPorDia, cargandoPrecios, carregarPreusMes } = usePreciosCalendario(
        '/preciosbuscadorgeneral',
        { idPropiedad: propiedad.id }
    );

    registerLocale('es', es);


    registerLocale('ca', ca);
    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    let results = [];
    let results2 = [];

    let entr = llegada != null ? parseISO(llegada) : null;
    let sali = salida != null ? parseISO(salida) : null;

    let primdialibre = parseISO(primerdialibre);

    const [showprop, setShowProp] = useState('none');
    const handleShowProp = () => {
        if (showprop == "none") setShowProp("block");
        else setShowProp("none");
    }
    const [dateRange, setDateRange] = useState([entr, sali])
    const [startDate, endDate] = dateRange;


    let botones = document.querySelectorAll(".boton");

    const cuandoSeHaceClick = function (evento) {

        var nuevo_mes = this.getAttribute("data-nuevo-mes");
        var nuevo_ano = this.getAttribute("data-nuevo-ano");

        let token = document.getElementById('meta_token').getAttribute('content');

        const result = axios.post('/calendario0', {
            idPropiedad: propiedad.id,
            nuevo_mes: nuevo_mes,
            nuevo_ano: nuevo_ano,
            bloqueos: JSON.stringify(diasbloqueados),
            bloqueossolos: JSON.stringify(diasbloqueadossolos),
            lang: lang
        }, {
            headers: {
                'content-type': 'text/json',
                'X-CSRF-TOKEN': token
            }
        })
            .then((response) => {
                document.querySelectorAll(".calendario")[0].innerHTML = response.data;
                botones = document.querySelectorAll(".boton");
                botones.forEach(boton => {
                    boton.addEventListener("click", cuandoSeHaceClick);
                })
            })

    }

    botones.forEach(boton => {
        boton.addEventListener("click", cuandoSeHaceClick);
    })

    let textopersonas = t("Personas");

    if (adultos > 0 || ninos > 0 || bebes > 0) {
        textopersonas = "";
        if (adultos > 0)
            textopersonas += " " + adultos + " " + t("Adultos");
        if (ninos > 0)
            textopersonas += " " + ninos + " " + t("Niños");
        if (bebes > 0)
            textopersonas += " " + bebes + " " + t("Bebés");
    }

    const numpersonas = useRef(null);
    const formpersonasRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const dropdown = formpersonasRef.current;
            const trigger = numpersonas.current;

            if (dropdown && !dropdown.contains(event.target) &&
                trigger && !trigger.contains(event.target)) {
                setShowProp('none');
            }
        };

        // Agregar el event listener
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            // Limpiar el event listener
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => {
        setShowModal(!showModal);
    }

    let dias = [];

    {
        diasbloqueadoscal.forEach((undia, index) => {
            dias.push(new Date(undia))
        })
    }

    {/* *************** */ }

    const [countAdults, setCountAdults] = useState(parseInt(adultos));
    const [countNinos, setCountNinos] = useState(parseInt(ninos));
    const [countBebes, setCountBebes] = useState(parseInt(bebes));

    const handleSumaAdultos = () => {
        if (countAdults + countNinos < propiedad.capacidad_maxima) {
            setCountAdults(ca => ca + 1);
            handleEtiqueta(parseInt(countAdults) + 1, parseInt(countNinos), parseInt(countBebes));
        }
    }

    const handleRestaAdultos = () => {
        if (countAdults > 0) {
            setCountAdults(ca => ca - 1);
            handleEtiqueta(parseInt(countAdults) - 1, parseInt(countNinos), parseInt(countBebes));
        }
    }

    const handleSumaNinos = () => {
        if (countNinos + countAdults < propiedad.capacidad_maxima) {
            setCountNinos(cn => cn + 1);
            handleEtiqueta(parseInt(countAdults), parseInt(countNinos) + 1, parseInt(countBebes));
        }
    }

    const handleRestaNinos = () => {
        if (countNinos > 0) {
            setCountNinos(cn => cn - 1);
            handleEtiqueta(parseInt(countAdults), parseInt(countNinos) - 1, parseInt(countBebes));
        }

    }

    const handleSumaBebes = () => {
        if (countBebes < propiedad.capacidad_maxima) {
            setCountBebes(cb => cb + 1);
            handleEtiqueta(parseInt(countAdults), parseInt(countNinos), parseInt(countBebes) + 1);
        }
    }

    const handleRestaBebes = () => {
        if (countBebes > 0) {
            setCountBebes(cb => cb - 1);
            handleEtiqueta(parseInt(countAdults), parseInt(countNinos), parseInt(countBebes) - 1);
        }
    }

    const handleEtiqueta = (adults, ninos, bebes) => {

        let frase = t("Personas");
        if (adults > 0) frase = " " + adults + " " + t("Adultos");
        if (ninos > 0) frase += " " + ninos + " " + t("Niños");
        if (bebes > 0) frase += " " + bebes + " " + t("Bebés");

        numpersonas.current.textContent = frase;
    }

    {/* *************** */ }

    // Resultat de "Buscar disponibilitat": dades estructurades (no HTML en
    // text) que es pinten com la targeta de reserva del carret de Reserva.
    const [resultado, setResultado] = useState(null);
    const [tarifaId, setTarifaId] = useState(null);
    const tarifaSel = resultado?.tarifas?.find((x) => x.id === tarifaId) ?? resultado?.tarifas?.[0];

    const construirResultado = (solucion, rangoUrl, rangoVisible) => {
        if (solucion.Error != "OK") {
            const aviso = solucion.diasminimos
                ? t("Estancia mínima") + ": " + solucion.diasminimos + " " + t("Noches")
                : t(solucion.Error) + (configweb.textonodispo ? "<br>" + configweb.textonodispo : "");
            return { tipo: "error", mensaje: aviso };
        }

        const extrasSol = solucion.extras.relacion_extras;
        const personas = Number(countAdults) + Number(countNinos);
        const porPeticion = propiedad.by_request == 1;

        const tarifas = solucion.precios.map((precios) => {
            const noches = precios.calendario_sin_otas.length;
            const estancia = precios.suma * 0.01;
            let total = estancia;
            const lineas = [];

            if (!porPeticion) {
                const nochesAMultiplicar = Math.min(noches, destino.maximo_dias);
                extrasSol.forEach((extra) => {
                    if (extra.obligatorio != 1) return;
                    let importe = extra.precio;
                    if (extra.tipo_precio == 1) {
                        if (extra.por_persona == 1) importe = importe * personas;
                        if (extra.por_dia_reserva == 1) importe = importe * noches;
                    } else {
                        importe = estancia * (importe / 100);
                        if (extra.por_persona == 1) importe = importe * personas;
                        if (extra.por_dia_reserva == 1) importe = importe * nochesAMultiplicar;
                    }
                    lineas.push({ nombre: extra.nombre, importe: importe * 0.01 });
                    total += importe * 0.01;
                });
            }

            const base = "/" + preidioma + t(porPeticion ? "peticion" : "reserva")
                + "?idpropiedad=" + propiedad.id
                + "&daterange=" + rangoUrl
                + "&adultos=" + Number(countAdults)
                + "&ninos=" + Number(countNinos)
                + "&bebes=" + Number(countBebes)
                + "&solorequest=" + (porPeticion ? 1 : 0)
                + "&tarifa=" + precios.id;

            return {
                id: precios.id,
                nombre: precios.info_tarifa.nombre_web,
                politica: precios.info_tarifa.politica?.nombre?.[lang],
                noches,
                estancia,
                lineas,
                total,
                href: base,
            };
        });

        return { tipo: porPeticion ? "peticion" : "ok", tarifas, personas, rango: rangoVisible };
    };

    const handleSubmit = (e) => {
        e.preventDefault()

        let token = document.getElementById('meta_token').getAttribute('content');
        const rango = e.target.daterange.value;

        axios.post('/haydispo', {
            id: propiedad.id,
            range: rango,
            personas: Number(countAdults) + Number(countNinos),
        }, {
            headers: {
                'content-type': 'text/json',
                'X-CSRF-TOKEN': token
            }
        })
            .then((response) => {
                setResultado(construirResultado(response.data, rango, rango));
            });
    }

    useEffect(() => {
        if (adultos > 0 && entr != null && sali != null) {

            let token = document.getElementById('meta_token').getAttribute('content');

            const opciones = { day: '2-digit', month: '2-digit', year: 'numeric' };
            const llegadaFormateada = new Date(llegada).toLocaleDateString('es-ES', opciones);
            const salidaformateada = new Date(salida).toLocaleDateString('es-ES', opciones);

            axios.post('/haydispo', {
                id: propiedad.id,
                range: llegadaFormateada + " - " + salidaformateada,
                personas: Number(countAdults) + Number(countNinos),
            }, {
                headers: {
                    'content-type': 'text/json',
                    'X-CSRF-TOKEN': token
                }
            })
                .then((response) => {
                    setResultado(construirResultado(
                        response.data,
                        llegada.replaceAll("-", "/") + " - " + salida.replaceAll("-", "/"),
                        llegadaFormateada + " - " + salidaformateada
                    ));
                });
        }
    }
        , [])

    {/* *************** */ }

    {
        servicios.forEach((unservicio, index) => {
            results = results.concat(
                <div className="col-md-4 col-sm-4 col-xs-6 altura30" title={unservicio.elnombre} data-original-title={unservicio.elnombre} key={"s" + index}>
                    <i className="fa fa-check fa-1-5x"></i> <span className="with-icon">{unservicio.elnombre}</span>
                </div>
            )
        })
    }

    {/* ********************** */ }

    const handleFocus = (e) => {
        const { target } = e;

        if (target) {
            target.readOnly = true;  // -------> this for all others
            target.blur(); //  ------> this for ios iphone
        }
    };

    const [cMeses, setCMeses] = useState(2);
    const [posCal, setPosCal] = useState("top-end");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1023);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 1023);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (isMobile) {
            setCMeses(1);
            setPosCal("bottom-end");
        }
        else {
            setCMeses(2);
            setPosCal("top-end");
        }
    }, [isMobile, cMeses, posCal]);

    {/* *************** */ }

    return (
        <div className="container">
            <div className="row">
                <div className="order-last mb-5 col-md-7 col-lg-8 order-sm-first">
                    <div className="detail-header">
                        <h2>
                            {
                                propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ?
                                    propiedad.nombre_traducido[lang]
                                    :
                                    propiedad.nombre
                            }
                        </h2>
                        <p className="mb-0">{propiedad.ciudad},  {propiedad.ladesc ? <>- <a href="#detail-content-sticky-nav-04" className="font13 anchor" data-toggle="tab"><i className="fa-duotone fa-map-marker"></i> {t("Mostrar mapa")}</a></> : null}</p>
                        <div className="mt-2 linia"></div>
                        <div className="mt-2 row icones-propietat">
                            <div className="col-md-2 col-6 centradoalineado mb-15">
                                <center>
                                    <div className="iconoprop">
                                        <i className="fa-duotone fa-home font30"></i>
                                    </div>
                                </center>
                                <br />
                                <span className="dobletam">
                                    {propiedad.metros_cuadrados} M2
                                </span>
                            </div>

                            <div className="col-md-2 col-6 centradoalineado mb-15">
                                <center>
                                    <div className="iconoprop">
                                        <i className="fa-duotone fa-bed font30"></i>
                                    </div>
                                </center>
                                <br />

                                <span className="dobletam">
                                    {propiedad.num_habitaciones} {t("Habitaciones")}
                                </span>
                            </div>

                            <div className="col-md-2 col-6 centradoalineado mb-15">
                                <center>
                                    <div className="iconoprop">
                                        <i className="fa-duotone fa-users font30"></i>
                                    </div>
                                </center>

                                <br />

                                <span className="dobletam">
                                    {propiedad.capacidad_maxima} {t("Adultos")}
                                </span>
                            </div>

                            <div className="col-md-2 col-6 centradoalineado mb-15">
                                <center>
                                    <div className="iconoprop">
                                        <i className="fa-duotone fa-bath font30"></i>
                                    </div>
                                </center>

                                <br />

                                <span className="dobletam">
                                    {propiedad.num_banyos} {t("Baños")}
                                </span>
                            </div>

                            {propiedad.num_sofas_cama > 0 ?
                                <div className="col-md-2 col-6 centradoalineado mb-15">
                                    <center>
                                        <div className="iconoprop op08">
                                            <i className="fa-duotone fa-couch font30"></i>
                                        </div>
                                    </center>

                                    <br />

                                    <span className="dobletam">
                                        {propiedad.num_sofas_cama} {t("Sofá Cama")}</span>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>

                    <div id="detail-content-sticky-nav-03" className="pt-3">
                        {
                            servicios.length > 0
                                ?
                                <>
                                    <button className="mt-3 mb-3 btn btn-serveis" onClick={() => handleShowModal()}>
                                        {servicios.length > 1 ?
                                            t("Muestra los") + " " + servicios.length + " " + t("servicios")
                                            :
                                            t("Muestra el") + " " + t("servicio")
                                        }
                                    </button>

                                    <Modal
                                        show={showModal} onHide={() => setShowModal(false)}
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered
                                        size="lg"
                                    >
                                        <Modal.Header closeButton>
                                            <Modal.Title>{t("¿Qué ofrece este espacio?")}</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className="clearfix mb-20 ml-20 row">
                                                {results}
                                            </div>
                                        </Modal.Body>
                                    </Modal>
                                </>
                                :
                                ""
                        }
                    </div>

                    {
                        propiedad.ladesc ?
                            <>
                                <div className="mt-4 multiple-sticky hidden-sm hidden-xs stickyminheight caixa-seccions sticky-top">
                                    <div className="multiple-sticky-inner">
                                        <div className="multiple-sticky-container">
                                            <div className="clearfix multiple-sticky-item">
                                                <ul id="multiple-sticky-menu" className="clearfix multiple-sticky-nav">
                                                    <li className="">
                                                        <a href="#detail-content-sticky-nav-03">{t("Habitaciones & comodidades")}</a>
                                                    </li>
                                                    <li className="">
                                                        <a href="#detail-content-sticky-nav-02">{t("Descripción")}</a>
                                                    </li>
                                                    <li className="">
                                                        <a href="#detail-content-sticky-nav-04">{t("Mapa & vecindario")}</a>
                                                    </li>
                                                    <li className="">
                                                        <a href="#detail-content-sticky-nav-05">{t("Disponibilidad")}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>
                            :
                            null
                    }


                    <div className="mb-5 detail-content-for-sticky-menu">
                        <div className="clear"></div>
                        {
                            propiedad.ladesc ?
                                <>
                                    <div id="detail-content-sticky-nav-02" className="mb-5">
                                        <div className="mb-40 section-title-3">
                                            <h3>{t("Descripción")}</h3>
                                        </div>
                                        <div id="descriptiontext">
                                            <div className="justificar">
                                                <div dangerouslySetInnerHTML={{ __html: propiedad.ladesc }}></div>
                                            </div>
                                        </div>

                                        <div className="mt-4 linia"></div>

                                        <h5 className="mt-4 mb-4 text-uppercase">{t("Información")}</h5>

                                        <ul className="descripcions-propietat">
                                            {propiedad.hora_checkin && propiedad.hora_checkout ?
                                                <li>
                                                    <span className="fw-bolder">{t("Horas de entrada/salida")}</span>
                                                    <div id="horariotext">
                                                        <p className="justificar">
                                                            {t("Check-in: a partir de las") + " " + propiedad.hora_checkin + "h"}
                                                            <br />
                                                            {t("Check out: antes de las") + " " + propiedad.hora_checkout + "h."}
                                                            <br />
                                                            {t("Si necesita entrar/salir antes o después de dichas horas, deberá solicitarlo en el momento de la reserva. Estas opciones quedan sujetas a disponibilidad y pueden generar un coste adicional.")}
                                                        </p>
                                                    </div>
                                                </li>
                                                :
                                                null
                                            }
                                            {politicas.length > 0 ?
                                                <li>
                                                    <span className="fw-bolder">{t("Cancelaciones")}</span>
                                                    {politicas.forEach((unapolitica, index) => {
                                                        results2 = results2.concat(
                                                            <div key={"p" + index}>
                                                                <strong>{unapolitica.elnombre}</strong><br></br>
                                                                <span dangerouslySetInnerHTML={{ __html: limpiarHtml(unapolitica.ladesc) }}></span>
                                                            </div>
                                                        )
                                                    })}
                                                    {results2}
                                                </li>
                                                :
                                                null
                                            }
                                            {propiedad.lainfo ?
                                                <li>
                                                    <span className="fw-bolder">{t("Información adicional")}</span>
                                                    <div id="adicionaltext">
                                                        <span dangerouslySetInnerHTML={{ __html: propiedad.lainfo }}></span>
                                                    </div>
                                                </li>
                                                :
                                                null
                                            }
                                            {propiedad.textras ?
                                                <li>
                                                    <span className="fw-bolder">{t("Servicios Exclusivos")}</span>
                                                    <div id="luxuryservices">
                                                        <span dangerouslySetInnerHTML={{ __html: propiedad.textras }}></span>
                                                    </div>
                                                </li>
                                                :
                                                null
                                            }
                                            {propiedad.hutb ?
                                                <li>
                                                    <span className="fw-bolder">{t("Número de licencia")}</span>
                                                    <div id="licence">
                                                        <p className="justificar ms-5">{propiedad.hutb}</p>
                                                    </div>
                                                </li>
                                                :
                                                null
                                            }
                                            {propiedad.registro_alquiler_corta_duracion ?
                                                <li>
                                                    <span className="fw-bolder">{t("Número de registro") + " " + t("Alquiler de Corta Duración")}</span>
                                                    <div id="licence">
                                                        <p className="justificar ms-5">{propiedad.registro_alquiler_corta_duracion}</p>
                                                    </div>
                                                </li>
                                                :
                                                null
                                            }
                                            {propiedad.registro_alquiler_larga_duracion ?
                                                <li>
                                                    <span className="fw-bolder">{t("Número de registro") + " " + t("Alquiler de Larga Duración")}</span>
                                                    <div id="licence">
                                                        <p className="justificar ms-5">{propiedad.registro_alquiler_larga_duracion}</p>
                                                    </div>
                                                </li>
                                                :
                                                null
                                            }
                                        </ul>
                                    </div>

                                    <div className="mt-4 linia"></div>

                                    <div id="detail-content-sticky-nav-04" className="pt-5">
                                        <div className="section-title-3">
                                            <h3>{t("Mapa & vecindario")}</h3>
                                        </div>

                                        <div className="map-and-friends">
                                            <MapContainer center={[propiedad.latitud, propiedad.longitud]} zoom={18} scrollWheelZoom={false}>
                                                <TileLayer
                                                    attribution='Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                                                    url="https://api.mapbox.com/styles/v1/bedloop/cmd4d8dxy00nd01s9aqzg9ba3/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiYmVkbG9vcCIsImEiOiJjbWQ0YTdxMHkwY3ZtMmtzZDl5ODNlcWFwIn0.eemxsflG0V9mZI4OFdhomg"
                                                />
                                                <Marker position={[propiedad.latitud, propiedad.longitud]}></Marker>
                                            </MapContainer>
                                        </div>
                                        <div className="mt-3 bb"></div>
                                    </div>
                                </>
                                :
                                null
                        }
                        {
                            propiedad.calendario_disponibilidad == 1 ?
                                <div id="detail-content-sticky-nav-05" className="pt-5">
                                    <div className="mt-4 mb-4 section-title-3">
                                        <h3>{t("Disponibilidad")}</h3>
                                    </div>

                                    <div className="calendario" align="center">
                                        <div dangerouslySetInnerHTML={{ __html: calendario }}></div>
                                    </div>

                                    <ul className="clearfix map-neighbour-label">
                                        <li className="color-04">
                                            {t("Ocupado")}
                                        </li>
                                        <li className="color-05">
                                            {t("Se puede salir")}
                                        </li>
                                        <li className="color-06">
                                            {t("Se puede entrar")}
                                        </li>
                                    </ul>
                                </div>
                                :
                                null
                        }
                    </div>

                    <div className="linia"></div>

                    <div className="mt-5 mb-4 section-title-3">
                        <h3>{config.nombre_comercial}</h3>
                    </div>

                    <div className="row">
                        <div className="col-sm-6">
                            <div className="featured-item-2">
                                <div className="icon">
                                    <i className="fa-duotone fa-credit-card"></i>
                                </div>
                                <p>{t("Protección de pago 100%")}</p>
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="featured-item-2">
                                <div className="icon">
                                    <i className="fa-duotone fa-comments"></i>
                                </div>
                                <p>{t("Comentarios reales")}</p>
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="featured-item-2">
                                <div className="icon">
                                    <i className="fa-duotone fa-images"></i>
                                </div>
                                <p>{t("Imágenes y videos reales")}</p>
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="featured-item-2">
                                <div className="icon">
                                    <i className="fa-duotone fa-tags"></i>
                                </div>
                                <p>{t("Siempre mejores precios")}</p>
                            </div>
                        </div>
                    </div>

                    <div className="mb-40"></div>
                </div>

                <div className="mb-5 col-md-5 col-lg-4 detail-right-sidebar">
                    <div className="mt-4 caixa-preus sticky-top">
                        <div className="price"></div>
                        <div className="inner">
                            <form className="gap-10 row" name="buscaDisponibilidad" method="GET" id="buscaDisponibilidad" onSubmit={handleSubmit}>
                                <input type="hidden" id="lang" name="lang" value={lang} />
                                <input type="hidden" id="moneda" name="moneda" value="EUR" />
                                <div className="m-0 border-0 bd-example fitxa-prop">
                                    <div className="mb-3">
                                        <DatePicker
                                            isClearable={true}
                                            onChange={(update) => {
                                                setDateRange(update);
                                            }}
                                            excludeDates={dias}
                                            className="form-control mw201 cpointer"
                                            autoComplete="off"
                                            startDate={startDate}
                                            endDate={endDate}
                                            selectsRange={true}
                                            dateFormat="dd/MM/yyyy"
                                            minDate={new Date()}
                                            openToDate={primdialibre}
                                            filterDate={(d) => d >= primdialibre}
                                            placeholderText={t("Entrada - Salida")}
                                            locale={lang}
                                            name="daterange"
                                            fixedHeight
                                            popperPlacement={posCal}
                                            monthsShown={cMeses}
                                            onCalendarOpen={() => carregarPreusMes(startDate || new Date(), cMeses)}
                                            onMonthChange={(date) => carregarPreusMes(date, cMeses)}
                                            renderDayContents={(day, date) => {
                                                const precio = preciosPorDia[fechaAPreciosKey(date)];
                                                return (
                                                    <>
                                                        {day}
                                                        <small className="mh-precio-dia">
                                                            {precio > 0
                                                                ? Math.round(precio / 100) + '€'
                                                                : cargandoPrecios
                                                                    ? <span className="mh-precio-dia__spinner"></span>
                                                                    : ' '}
                                                        </small>
                                                    </>
                                                );
                                            }}
                                            calendarContainer={({ className, children }) => (
                                                <div className={className}>
                                                    {cargandoPrecios && (
                                                        <div className="mh-precios-spinner" aria-live="polite">
                                                            <span className="mh-precios-spinner__dot"></span>
                                                            {t("Cargando precios")}...
                                                        </div>
                                                    )}
                                                    {children}
                                                </div>
                                            )}
                                            onFocus={handleFocus}
                                        >
                                        </DatePicker>
                                    </div>

                                    <div className="mb-3">
                                        <div onClick={handleShowProp} className="form-control numpersonas mw201" ref={numpersonas}>{textopersonas}</div>

                                        {/* ********* */}

                                        <div className="formpersonas formficha" style={{ display: showprop }} onBlur={handleShowProp} tabIndex="0" onMouseLeave={handleShowProp} ref={formpersonasRef}>
                                            <div className="mt-2 row">
                                                <label className="col-md-6 col-6 etiqueta-formulari"> {t("Adultos")}<div className="mini-etiqueta-formulari">({t("Desde_12_años")})</div></label>
                                                <div className="col-md-4 col-6">
                                                    <div className="mt-4 input-group">
                                                        <span className="input-group-btn">
                                                            <button className="btn btn-xs btn-number boto-cercle" type="button" data-type="minus" data-field="my_multi_select_adultos" onClick={handleRestaAdultos}>
                                                                <span className="centrar-boto-cercle">
                                                                    <svg viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}><rect height="2" rx="1" width="12" x="6" y="11"></rect></svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                        <input type="text" name="adultos" className="form-control input-number numero-persones" value={countAdults} min="0" max={propiedad.capacidad_maxima} id="numadultos" readOnly={true} />
                                                        <span className="input-group-btn">
                                                            <button type="button" className="btn btn-xs btn-number boto-cercle" data-type="plus" data-field="my_multi_select_adultos" onClick={handleSumaAdultos}>
                                                                <span className="centrar-boto-cercle">
                                                                    <svg viewBox="0 0 24 24" role="img" aria-label="add" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }} >
                                                                        <rect height="2" rx="1" width="12" x="6" y="11"></rect><rect height="12" rx="1" width="2" x="11" y="6"></rect>
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="linia"></div>

                                            <div className="mt-3 row">
                                                <label className="col-md-6 col-6 etiqueta-formulari"> {t("Niños")}<div className="mini-etiqueta-formulari">({t("De_2_a_12_años")})</div></label>
                                                <div className="col-md-4 col-6">
                                                    <div className="mt-4 input-group">
                                                        <span className="input-group-btn">
                                                            <button type="button" className="btn btn-xs btn-number boto-cercle" data-type="minus" data-field="my_multi_select_ninos" onClick={handleRestaNinos}>
                                                                <span className="centrar-boto-cercle">
                                                                    <svg viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}><rect height="2" rx="1" width="12" x="6" y="11"></rect></svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                        <input type="text" name="ninos" className="form-control input-number numero-persones" value={countNinos} min="0" max={propiedad.capacidad_maxima} id="numninos" readOnly={true} />
                                                        <span className="input-group-btn">
                                                            <button type="button" className="btn btn-xs btn-number boto-cercle" data-type="plus" data-field="my_multi_select_ninos" onClick={handleSumaNinos}>
                                                                <span className="centrar-boto-cercle">
                                                                    <svg viewBox="0 0 24 24" role="img" aria-label="add" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}>
                                                                        <rect height="2" rx="1" width="12" x="6" y="11"></rect><rect height="12" rx="1" width="2" x="11" y="6"></rect>
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="linia"></div>

                                            <div className="mt-3 row">
                                                <label className="col-md-6 col-6 etiqueta-formulari"> {t("Bebés")}<div className="mini-etiqueta-formulari">{t("De_0_a_2_años")}</div></label>
                                                <div className="col-md-4 col-6">
                                                    <div className="mt-4 input-group">
                                                        <span className="input-group-btn">
                                                            <button type="button" className="btn btn-xs btn-number boto-cercle" datatype="minus" datafield="my_multi_select_bebes" onClick={handleRestaBebes}>
                                                                <span className="centrar-boto-cercle">
                                                                    <svg viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}>
                                                                        <rect height="2" rx="1" width="12" x="6" y="11"></rect>
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                        <input type="text" name="bebes" className="form-control input-number numero-persones" value={countBebes} min="0" max={propiedad.capacidad_maxima} id="numbebes" readOnly={true} />
                                                        <span className="input-group-btn">
                                                            <button type="button" className="btn btn-xs btn-number boto-cercle" data-type="plus" data-field="my_multi_select_bebes" onClick={handleSumaBebes}>
                                                                <span className="centrar-boto-cercle">
                                                                    <svg viewBox="0 0 24 24" role="img" aria-label="add" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}>
                                                                        <rect height="2" rx="1" width="12" x="6" y="11"></rect><rect height="12" rx="1" width="2" x="11" y="6"></rect>
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* ********* */}
                                    </div>
                                </div>

                                <div className="gap-2 d-grid">
                                    <button type="submit" className="mt-2 btn btn-primary btn-icon" style={{ background: "" + configweb.color_corporativo_web + "", border: "1px solid" + configweb.color_corporativo_web }}>
                                        {propiedad.by_request == 1
                                            ? t("Buscar disponibilidad") + " " + t("Petición")
                                            : t("Buscar disponibilidad")
                                        }
                                    </button>
                                    <span className="text-center gris"> {t("No se te cobrará nada aún")}</span>
                                </div>

                                <div className="mb-1 clear"></div>

                                <div className="mt-3">
                                    {resultado && resultado.tipo === "error" && (
                                        <div className="bh-reserva-aviso" dangerouslySetInnerHTML={{ __html: limpiarHtml(resultado.mensaje) }}></div>
                                    )}

                                    {resultado && resultado.tarifas && tarifaSel && (
                                        <div className="bh-cart bh-reserva-resultados">
                                            {resultado.rango && (
                                                <span className="bh-cart__badge">
                                                    <i className="fa-regular fa-calendar"></i>
                                                    {resultado.rango}
                                                </span>
                                            )}

                                            <div className="bh-tarifas" role="radiogroup" aria-label={t("Tarifa")}>
                                                {resultado.tarifas.map((tarifa) => {
                                                    const activa = tarifa.id === tarifaSel.id;
                                                    return (
                                                        <label className={"bh-tarifa" + (activa ? " bh-tarifa--activa" : "")} key={tarifa.id}>
                                                            <input
                                                                type="radio"
                                                                name="bh-tarifa"
                                                                checked={activa}
                                                                onChange={() => setTarifaId(tarifa.id)}
                                                            />
                                                            <span className="bh-tarifa__radio"></span>
                                                            <span className="bh-tarifa__texto">
                                                                <strong>{tarifa.nombre}</strong>
                                                                {tarifa.politica && <small>{tarifa.politica}</small>}
                                                            </span>
                                                            {resultado.tipo === "ok" && (
                                                                <span className="bh-tarifa__precio">{tarifa.total.toFixed(2)} {moneda}</span>
                                                            )}
                                                        </label>
                                                    );
                                                })}
                                            </div>

                                            <div className="bh-cart__meta">
                                                <span><i className="fa-regular fa-moon"></i> {tarifaSel.noches} {t("Noches")}</span>
                                                <span><i className="fa-regular fa-user"></i> {resultado.personas} {t("Personas")}</span>
                                            </div>

                                            {resultado.tipo === "ok" && (
                                                <div className="bh-reserva-lineas">
                                                    {tarifaSel.lineas.map((linea, i) => (
                                                        <div className="bh-cart__extra" key={i}>
                                                            <span>{linea.nombre}</span>
                                                            <strong>{linea.importe.toFixed(2)} {moneda}</strong>
                                                        </div>
                                                    ))}
                                                    <div className="bh-reserva-total">
                                                        <span>{t("Total")}</span>
                                                        <strong>{tarifaSel.total.toFixed(2)} {moneda}</strong>
                                                    </div>
                                                </div>
                                            )}

                                            <a
                                                href={tarifaSel.href}
                                                className="btn btn-primary btn-icon w100 bh-reserva-cta"
                                                style={{ background: configweb.color_corporativo_web, border: "1px solid " + configweb.color_corporativo_web }}
                                            >
                                                {resultado.tipo === "peticion" ? t("Petición") : t("Reservar")}
                                            </a>
                                        </div>
                                    )}
                                </div>
                                <div className="clear"></div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default DatosPropiedad;
